import _ from 'lodash'
import { useNavigate } from 'react-router-dom'

import * as PatientFormMapper from '../../lib/Proxy/patient'
import { useAppDispatch } from '../../store'
import * as Actions from '../shared/PatientForm/actions'
import PatientForm from '../shared/PatientForm/form'

export function NewPatient (): JSX.Element {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  function handleSubmit (data: any): void {
    const res = { ...data }
    res.emails = _.compact(data.emails)
    res.phones = _.compact(data.phones)
    dispatch(Actions.savePatient(PatientFormMapper.mapFormToPatient(res), navigate))
  }

  return (
    <PatientForm
      // @ts-expect-error TODO: fix this
      onSubmit={handleSubmit}
      // @ts-expect-error TODO: fix this
      isNewPatient
      // @ts-expect-error TODO: fix this
      formKey='new-patient'
    />
  )
}
